/**
 * Returns the last item of an (async) iterable, unless empty, in which case
 * return `undefined`
 */
export default async function last(source) {
    let res;
    for await (const entry of source) {
        res = entry;
    }
    return res;
}
//# sourceMappingURL=index.js.map